<template>
    <div class="Details">
       <section>
          <div class="x">
            
             <div class="box">
                <h3>Insights</h3>
             
             </div>
          </div>
       </section>
    </div>
  </template>
  <script>

    
export default {
       props: ["project", "currentUser"],
       name: "Insights",
       data: function() {
        return {
            a: null
          }
        },
        components: {
          
        },
       created() {
         
       }
     };
  </script>
  